import { useMemo } from 'react';
import { Authorization } from '@/lib/authorization';
import { Identity } from './useIdentity';
import { IUser } from '@/types';
import { Config } from '@/hooks/useConfig';

export const useAuthorization = (currentUser?: IUser) => {
  const user = currentUser || Identity.useContainer().user;
  const { config } = Config.useContainer();

  const auth = useMemo(() => {
    return new Authorization({ user, config });
  }, [user, config]);

  return auth;
};

export default useAuthorization;
